var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationTrainAndPlatformBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3841px",
    height: "389px",
    viewBox: "0 0 3841 389",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Masthead/VTT-Landing-TrainAndPlatform_Desktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ASSETS",
    transform: "translate(-123.000000, -717.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Masthead/VTT-Landing-TrainAndPlatform_Desktop",
    transform: "translate(123.000000, 717.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "VTT_LandingPage_SurferIllustration-Platform",
    fill: "#E73B3B",
    fillRule: "nonzero",
    transform: "translate(1920.000000, 305.500000) scale(1, -1) translate(-1920.000000, -305.500000) ",
    x: 0,
    y: 222,
    width: 3840,
    height: 167
  }), /*#__PURE__*/React.createElement("g", {
    id: "Train",
    transform: "translate(1920.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    fill: "#ED6C6C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.983,221.996094 L1920.02148,221.996094 L1920.02148,0 L187.529,0 C180.463,0 158.45,7.05345627 134.074,26.7476516 L37.655,108.581965 C24.375,120.427526 0,139.641008 0,173.172717 C0,221.984076 60.943,221.984076 60.943,221.984076 L65.983,221.996094 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Undercarriage",
    transform: "translate(68.000000, 185.274657)",
    fill: "#EA5353"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.316,0 C61.922,0 3.682,34.5211753 0,36.725443 L1851.98828,36.725443 L1851.98828,0 L97.316,0 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1919.98047,173.256842 L1919.98047,165.357732 L0.463350594,165.357732 C0.161345296,167.897773 0,170.529421 0,173.256842 L1919.98047,173.256842 Z",
    id: "Stripe2",
    fill: "#F39D9D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8425026,124.184095 C13.0648319,132.607868 5.62640006,143.184429 2.11403708,156.617495 L1920.03784,156.617495 L1920.03784,124.184095 L20.8425026,124.184095 Z",
    id: "Stripe1",
    fill: "#F39D9D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.539099,42.0623546 L313.460901,42.0623546 C319.8273,42.0623546 325,47.2337572 325,53.6078116 L325,91.6074603 C325,97.9773676 319.831445,103.152917 313.460901,103.152917 L291.539099,103.152917 C285.1727,103.152917 280,97.9815146 280,91.6074603 L280,53.6078116 C280,47.2379043 285.168555,42.0623546 291.539099,42.0623546 Z",
    id: "Door-window",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.561447,39.0620475 L513.442704,39.0620475 C519.819143,39.0620475 525,44.2330991 525,50.6067207 L525,88.6037901 C525,94.973265 519.823294,100.148463 513.442704,100.148463 L377.557296,100.148463 C371.180857,100.148463 366,94.9774118 366,88.6037901 L366,50.602574 C366,44.2330991 371.176706,39.0579007 377.557296,39.0579007 L377.561447,39.0620475 Z",
    id: "Window4",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.56145,39.0620475 L1229.4427,39.0620475 C1235.81914,39.0620475 1241,44.2330991 1241,50.6067207 L1241,88.6037901 C1241,94.973265 1235.82329,100.148463 1229.4427,100.148463 L1093.5573,100.148463 C1087.18086,100.148463 1082,94.9774118 1082,88.6037901 L1082,50.602574 C1082,44.2330991 1087.17671,39.0579007 1093.5573,39.0579007 L1093.56145,39.0620475 Z",
    id: "Window4-Copy",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.557296,39.0620475 L692.442704,39.0620475 C698.819143,39.0620475 704,44.2330991 704,50.6067207 L704,88.6037901 C704,94.973265 698.823294,100.148463 692.442704,100.148463 L556.557296,100.148463 C550.180857,100.148463 545,94.9774118 545,88.6037901 L545,50.602574 C545,44.2330991 550.176706,39.0579007 556.557296,39.0579007 L556.557296,39.0620475 Z",
    id: "Window3",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.5573,39.0620475 L1408.4427,39.0620475 C1414.81914,39.0620475 1420,44.2330991 1420,50.6067207 L1420,88.6037901 C1420,94.973265 1414.82329,100.148463 1408.4427,100.148463 L1272.5573,100.148463 C1266.18086,100.148463 1261,94.9774118 1261,88.6037901 L1261,50.602574 C1261,44.2330991 1266.17671,39.0579007 1272.5573,39.0579007 L1272.5573,39.0620475 Z",
    id: "Window3-Copy",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.557296,39.0620475 L871.442704,39.0620475 C877.819143,39.0620475 883,44.2330991 883,50.6067207 L883,88.6037901 C883,94.973265 877.823294,100.148463 871.442704,100.148463 L735.557296,100.148463 C729.180857,100.148463 724,94.9774118 724,88.6037901 L724,50.602574 C724,44.2330991 729.176706,39.0579007 735.557296,39.0579007 L735.557296,39.0620475 Z",
    id: "Window2",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.5573,39.0620475 L1587.4427,39.0620475 C1593.81914,39.0620475 1599,44.2330991 1599,50.6067207 L1599,88.6037901 C1599,94.973265 1593.82329,100.148463 1587.4427,100.148463 L1451.5573,100.148463 C1445.18086,100.148463 1440,94.9774118 1440,88.6037901 L1440,50.602574 C1440,44.2330991 1445.17671,39.0579007 1451.5573,39.0579007 L1451.5573,39.0620475 Z",
    id: "Window2-Copy",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.553446,39.0620475 L1050.4424,39.0620475 C1056.81901,39.0620475 1062,44.2330991 1062,50.6067207 L1062,88.6037901 C1062,94.973265 1056.82316,100.148463 1050.4424,100.148463 L914.557598,100.148463 C908.180992,100.148463 903,94.9774118 903,88.6037901 L903,50.602574 C903,44.2330991 908.176841,39.0579007 914.557598,39.0579007 L914.553446,39.0620475 Z",
    id: "Window",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.55345,39.0620475 L1766.4424,39.0620475 C1772.81901,39.0620475 1778,44.2330991 1778,50.6067207 L1778,88.6037901 C1778,94.973265 1772.82316,100.148463 1766.4424,100.148463 L1630.5576,100.148463 C1624.18099,100.148463 1619,94.9774118 1619,88.6037901 L1619,50.602574 C1619,44.2330991 1624.17684,39.0579007 1630.5576,39.0579007 L1630.55345,39.0620475 Z",
    id: "Window-Copy",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.5576,39.0579007 L1809.55345,39.0620475 L1920,39.0619007 L1920,100.147901 L1809.5576,100.148463 C1803.18099,100.148463 1798,94.9774118 1798,88.6037901 L1798,50.602574 C1798,44.2330991 1803.17684,39.0579007 1809.5576,39.0579007 Z",
    id: "Combined-Shape",
    fill: "#E10A0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.716728,209.310288 L265.283272,209.310288 C259.062741,209.310288 254,204.153573 254,197.812263 L254,38.53811 C254,32.1968002 259.062741,27.0400851 265.283272,27.0400851 L326.716728,27.0400851 C332.937259,27.0400851 338,32.2009421 338,38.53811 L338,197.812263 C338,204.153573 332.937259,209.310288 326.716728,209.310288 Z M265.283272,28.9785129 C260.133386,28.9785129 255.94625,33.2654206 255.94625,38.53811 L255.94625,197.812263 C255.94625,203.080811 260.133386,207.371861 265.283272,207.371861 L326.716728,207.371861 C331.866614,207.371861 336.05375,203.084953 336.05375,197.812263 L336.05375,38.53811 C336.05375,33.2695626 331.866614,28.9785129 326.716728,28.9785129 L265.283272,28.9785129 Z",
    id: "Door",
    fill: "#F6B5B5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Door-handle",
    fill: "#F7C2C2",
    fillRule: "nonzero",
    x: 262.702105,
    y: 75.082445,
    width: 5.87194941,
    height: 81.3849753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.079133,99.1469787 L158.843838,99.1469787 C160.310675,99.1469787 161.498313,97.9651439 161.498313,96.5054742 L176,42.7008898 C176,41.2412201 174.812362,40.0593853 173.345525,40.0593853 L162.798464,40.0593853 C160.614877,40.0593853 158.502131,40.8389816 156.843605,42.2571834 L100.774582,90.2687039 C97.2075007,93.3207405 99.3785866,99.1428319 104.083301,99.1428319",
    id: "Path",
    fill: "#E10A0A",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationTrainAndPlatformBackground);
export default __webpack_public_path__ + "static/media/illustration-trainAndPlatform_background.28f22cf7986ed64fe29696a1f6f990ef.svg";
export { ForwardRef as ReactComponent };